<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// No imports needed - router-view is available globally
</script>
